<template>
  <button
    aria-label="Scrolle zum Inhaltsanfang"
    class="group relative cursor-pointer"
    type="button"
    @click="scrollTo()"
  >
    <IconArrowLinkBubble class="relative w-full rotate-90" />
  </button>
</template>

<script setup lang="ts">
function scrollTo() {
  const selector = '[scroll-to-index="0"]'
  const element = document.querySelector(selector)

  if (!element) {
    return
  }

  const headerOffset = 250
  const elementPosition = element.offsetTop
  const offsetPosition = elementPosition - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })
}
</script>
